
function percentage(num) {
  if (num === '-')
    return '';
  let number = num || 0
	const rounded = Math.round(number*100)/100
  const round = rounded.toFixed(2)
  return `${round}%`
}

export default percentage


// WEBPACK FOOTER //
// ./src/filters/percentage.js